import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance } from 'vue';
import { CombinationsConfiguratorFormData } from '@/modules/ConfiguratorCombinations/interfaces/CombinationsInterfaces';
import { ChecklistField } from '@/interfaces/components/configurator/ChecklistField';

interface Props {
    tableHeaderFields: any[];
    productRowsFormData: CombinationsConfiguratorFormData[];
    dropdownChecklistFields: ChecklistField[];
    combinationType: string;
    guideType: string;
    secondGuideType: string;
    pogonOptions: any[];
    secondPogonOptions: any[];
    shouldShowAssemblyCode: boolean;
    FilteredCombinationsOptions: any;
    currentConfig: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CombinationsProductDropdowns',
  props: {
    tableHeaderFields: null,
    productRowsFormData: null,
    dropdownChecklistFields: null,
    combinationType: null,
    guideType: null,
    secondGuideType: null,
    pogonOptions: null,
    secondPogonOptions: null,
    shouldShowAssemblyCode: { type: Boolean },
    FilteredCombinationsOptions: null,
    currentConfig: null
  },
  emits: ["updateFormField", "updateVodilaField"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'updateFormField', payload: { productId: number; fieldPID: string; value: string }): void;
    (e: 'updateVodilaField', payload: { value: string; vodilaNumber: number }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    tableHeaderFields: any[];
    productRowsFormData: CombinationsConfiguratorFormData[];
    dropdownChecklistFields: ChecklistField[];
    combinationType: string;
    guideType: string;
    secondGuideType: string;
    pogonOptions: any[];
    secondPogonOptions: any[];
    shouldShowAssemblyCode: boolean;
    FilteredCombinationsOptions: any;
    currentConfig: any;
};





const { proxy } = getCurrentInstance()!;

function getDimensionsText(row: CombinationsConfiguratorFormData): string {
    const width =
        row.formData.find((field) => field.fieldPID === props.FilteredCombinationsOptions.WIDTH_PID)?.fieldValue || '-';
    const height =
        row.formData.find((field) => field.fieldPID === props.FilteredCombinationsOptions.HEIGHT_PID)?.fieldValue ||
        '-';
    return `${width} × ${height}`;
}

function getDropdownFields(row: CombinationsConfiguratorFormData) {
    return row.formData
        .map((field) => {
            const headerField = props.tableHeaderFields.find((headerField) => headerField.pid === field.fieldPID);

            if (headerField && headerField.type === 'dropdown' && headerField.active) {
                return {
                    ...field,
                    options:
                        props.dropdownChecklistFields.find((checklist) => checklist.pId === field.fieldPID)
                            ?.checklistDropdownField?.checklistDropdownOptions || [],
                };
            }
            return null;
        })
        .filter((field): field is NonNullable<typeof field> => field !== null && field !== undefined);
}

function onDropdownChange(productId: number, fieldPID: string, value: string) {
    emit('updateFormField', { productId, fieldPID, value });
}

function onVodilaDropdownChange(value: string, vodilaNumber: number) {
    emit('updateVodilaField', { value, vodilaNumber });
}

function getSystemAndRowIdLabel(row: CombinationsConfiguratorFormData, rowIndex: number): string {
    const system =
        row.formData.find((field) => field.fieldPID === props.FilteredCombinationsOptions.SISTEM_PID)?.fieldValue || '';
    return `${system} - ${rowIndex + 1}`; // +1 to make it 1-based index
}

return { __sfc: true,props, emit, proxy, getDimensionsText, getDropdownFields, onDropdownChange, onVodilaDropdownChange, getSystemAndRowIdLabel }
}

})